/*هتل*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={97.027}
      height={97.045}
      viewBox="0 0 97.027 97.045"
      {...props}
    >
      <g data-name="hotel (2)">
        <path
          data-name="Path 7649"
          d="M76.556 76.002a18.2 18.2 0 0012.289-31.615 12.294 12.294 0 00-12.289-11.976z"
          fill="#62cd4d"
        />
        <path
          data-name="Path 7650"
          d="M33.519 82.126a11.677 11.677 0 10-22.478 4.436 8.437 8.437 0 00-.553-.02 8.592 8.592 0 00-8.592 8.593h31.623z"
          fill="#baea83"
        />
        <path
          data-name="Rectangle 684"
          fill="#c9f3ff"
          d="M20.497 23.882h56.059V95.15H20.497z"
        />
        <g data-name="Group 362" fill="#72d8ff">
          <path
            data-name="Rectangle 685"
            d="M41.047 74.301H56.21v20.85H41.047z"
          />
          <path
            data-name="Rectangle 686"
            d="M27.59 34.118h9.098v10.614H27.59z"
          />
        </g>
        <g data-name="Group 363" fill="#fff">
          <path
            data-name="Rectangle 687"
            d="M44.08 34.118h9.098v10.614H44.08z"
          />
          <path
            data-name="Rectangle 688"
            d="M60.568 34.118h9.098v10.614h-9.098z"
          />
          <path
            data-name="Rectangle 689"
            d="M27.59 54.209h9.098v10.614H27.59z"
          />
        </g>
        <g data-name="Group 364" fill="#72d8ff">
          <path
            data-name="Rectangle 690"
            d="M44.08 54.209h9.098v10.614H44.08z"
          />
          <path
            data-name="Rectangle 691"
            d="M60.568 54.209h9.098v10.614h-9.098z"
          />
        </g>
        <path
          data-name="Path 7651"
          d="M61.701 91.958h27.873l5.558.009v-6.205a5.444 5.444 0 00-5.444-5.444H53.972a5.444 5.444 0 00-5.444 5.444v6.21l6.464-.009z"
          fill="#ffc66c"
        />
        <path
          data-name="Path 7652"
          d="M78.095 68.777h-14.16a4.355 4.355 0 00-4.009 2.653l-3.773 8.888h29.724l-3.773-8.888a4.355 4.355 0 00-4.009-2.653z"
          fill="#c9f3ff"
        />
        <g
          data-name="Group 365"
          transform="translate(54.867 87.568)"
          fill="#898998"
        >
          <circle data-name="Ellipse 363" cx={3.791} cy={3.791} r={3.791} />
          <circle
            data-name="Ellipse 364"
            cx={3.791}
            cy={3.791}
            r={3.791}
            transform="translate(27.872)"
          />
        </g>
        <path
          data-name="Path 7653"
          d="M26.25 78.045a1.894 1.894 0 10-.555-1.34 1.909 1.909 0 00.555 1.34z"
        />
        <path
          data-name="Path 7654"
          d="M20.497 42.931a1.9 1.9 0 10-1.34-.556 1.9 1.9 0 001.34.556z"
        />
        <path
          data-name="Path 7655"
          d="M27.59 46.627h9.1a1.9 1.9 0 001.9-1.9V34.122a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9v10.61a1.9 1.9 0 001.9 1.895zm1.9-10.614h5.307v6.823h-5.315z"
        />
        <path
          data-name="Path 7656"
          d="M44.078 46.627h9.1a1.9 1.9 0 001.9-1.9V34.122a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9v10.61a1.9 1.9 0 001.9 1.895zm1.9-10.614h5.3v6.823h-5.3v-6.823z"
        />
        <path
          data-name="Path 7657"
          d="M60.573 46.627h9.1a1.9 1.9 0 001.9-1.9V34.122a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9v10.61a1.9 1.9 0 001.9 1.895zm1.9-10.614h5.3v6.823h-5.307z"
        />
        <path
          data-name="Path 7658"
          d="M25.695 64.824a1.9 1.9 0 001.9 1.9h9.1a1.9 1.9 0 001.9-1.9v-10.61a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9zm3.791-8.719h5.307v6.824h-5.311z"
        />
        <path
          data-name="Path 7659"
          d="M42.184 64.824a1.9 1.9 0 001.9 1.9h9.1a1.9 1.9 0 001.9-1.9v-10.61a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9v10.61zm3.791-8.719h5.303v6.824h-5.3v-6.824z"
        />
        <path
          data-name="Path 7660"
          d="M58.673 63.114a1.9 1.9 0 103.791 0v-7.013h5.309v7.013a1.9 1.9 0 103.791 0v-8.9a1.9 1.9 0 00-1.9-1.9h-9.1a1.9 1.9 0 00-1.9 1.9z"
        />
        <path
          data-name="Path 7661"
          d="M23.137 20.091V1.9a1.9 1.9 0 10-3.791 0v7.2h-6.823V1.9a1.9 1.9 0 10-3.791 0v18.2a1.9 1.9 0 003.791 0v-7.2h6.824v7.2a1.9 1.9 0 003.791 0z"
        />
        <path
          data-name="Path 7662"
          d="M53.78 20.091v-16.3h3.412a1.9 1.9 0 100-3.791H46.577a1.9 1.9 0 100 3.791h3.412v16.3a1.9 1.9 0 003.791 0z"
        />
        <path
          data-name="Path 7663"
          d="M42.723 14.784V7.2a7.202 7.202 0 00-14.405 0v7.582a7.202 7.202 0 0014.405 0zm-3.791 0a3.412 3.412 0 01-6.824 0V7.2a3.412 3.412 0 016.824 0z"
        />
        <path
          data-name="Path 7664"
          d="M89.687 78.422h-2.556l-1.153-2.717a20.088 20.088 0 005.016-32.169 14.187 14.187 0 00-12.543-12.925v-4.833h4.352a1.9 1.9 0 000-3.791h3.578a1.9 1.9 0 000-3.791h-6.13V1.9a1.9 1.9 0 10-3.791 0v18.2a1.9 1.9 0 001.9 1.9h-7.269a1.9 1.9 0 000-3.791h-6.128v-5.32h6.128a1.9 1.9 0 000-3.791h-6.128V3.791h6.128a1.9 1.9 0 000-3.791h-8.024a1.9 1.9 0 00-1.9 1.9v18.2a1.9 1.9 0 001.9 1.9H14.205a1.9 1.9 0 000 3.791h4.4v8.707a1.9 1.9 0 103.791 0v-8.72h52.265v41.1H63.935a6.24 6.24 0 00-5.753 3.808l-.731 1.714h-16.4a1.9 1.9 0 00-1.9 1.9v18.955h-5.4a1.907 1.907 0 00-.229-.015h-4.036V82.865a1.9 1.9 0 10-3.791 0v10.374h-3.3V47.954a1.9 1.9 0 00-3.791 0v20.991A13.584 13.584 0 008.541 84.828 10.505 10.505 0 000 95.135a1.9 1.9 0 001.9 1.9l46.609.015a1.893 1.893 0 001.387-3.184l3.659-.006a5.684 5.684 0 0010.216 0h17.65a5.684 5.684 0 0010.213.01h3.5a1.9 1.9 0 001.9-1.9v-6.208a7.348 7.348 0 00-7.347-7.34zm-6.674 0h-10.1v-7.75h5.185a2.456 2.456 0 012.264 1.5zm4.238-33.984a1.9 1.9 0 00.614 1.349A16.294 16.294 0 0184.491 72.2l-.64-1.511a6.237 6.237 0 00-5.4-3.795V34.429a10.33 10.33 0 018.8 10.009zM63.935 70.672h5.185v7.75h-10.1l2.651-6.252a2.456 2.456 0 012.264-1.498zM42.942 76.2h12.9l-.945 2.226h-.926a7.348 7.348 0 00-7.339 7.339v6.206a1.894 1.894 0 00.507 1.287h-4.2V76.2zM10.488 88.437c.126 0 .264 0 .433.016a1.9 1.9 0 001.873-2.612 9.791 9.791 0 015.809-12.951v20.35H4.064a6.709 6.709 0 016.424-4.803zm39.935-2.676a3.553 3.553 0 013.549-3.549H69.12v7.849h-4.928a5.685 5.685 0 00-11.071 0h-2.7zm8.234 7.493a1.9 1.9 0 111.9-1.9 1.9 1.9 0 01-1.9 1.901zm27.873 0a1.9 1.9 0 111.9-1.9 1.9 1.9 0 01-1.9 1.901zm6.706-3.182h-1.169a5.685 5.685 0 00-11.073-.01H72.91v-7.849h16.777a3.553 3.553 0 013.549 3.549z"
        />
        <path
          data-name="Path 7665"
          d="M66.223 87.434a1.9 1.9 0 001.9-1.9v-.014a1.9 1.9 0 10-1.9 1.91z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
